import SvgIcon from '@mui/material/SvgIcon';
import type { SVGIcon } from '../SVGIcon.ts';
import { SVGStyles } from '../SVGStyles.ts';

export const TVDevicesIcon = ({ height = 18, 'data-test': dataTest }: Readonly<SVGIcon>) => {
  return (
    <SvgIcon
      width="18"
      height={height}
      viewBox="0 0 18 18"
      data-test={dataTest}
      sx={{
        ...SVGStyles,
        width: 18,
        height,
        '& .antenna': {
          fill: 'none',
          stroke: 'currentColor',
          strokeLinecap: 'round',
          strokeWidth: 1.5,
        },
      }}
    >
      <path d="M3.5 16.75V15.25C3.0875 15.25 2.73438 15.1031 2.44062 14.8094C2.14687 14.5156 2 14.1625 2 13.75V5.5C2 5.0875 2.14687 4.73438 2.44062 4.44062C2.73438 4.14687 3.0875 4 3.5 4H15.5C15.9125 4 16.2656 4.14687 16.5594 4.44062C16.8531 4.73438 17 5.0875 17 5.5V13.75C17 14.1625 16.8531 14.5156 16.5594 14.8094C16.2656 15.1031 15.9125 15.25 15.5 15.25V16.75H14.75L14.2625 15.25H4.75625L4.25 16.75H3.5ZM3.5 13.75H15.5V5.5H3.5V13.75Z" />
      <path className="antenna" d="M11.5 2L9 4.5L5.5 0.5" />
      <rect x="4.5" y="6.8" width="7.6" height="5.5" rx="1" />
      <path d="M14.5 7.55a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
      <path d="M14.5 9.55a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
      <path d="M14.5 11.55a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" />
    </SvgIcon>
  );
};
